import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=08767011&"
import script from "./NotificationForm.vue?vue&type=script&lang=ts&"
export * from "./NotificationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports